import moment from 'moment'
import {intl} from '../../../_metronic/i18n/i18nProvider'
import {TransactionStatisticsModel} from './models/TransactionSatisticsModel'
import {DATE_ONLY_FORMAT} from '../../shared/constants'

export const convertTransactionStatisticToChartData = (
  transactionStatistic: TransactionStatisticsModel[]
) => {
  let series: {name: string; data: number[]}[] = []
  if (transactionStatistic && transactionStatistic.length === 0) {
    return {series, labels: []}
  }
  const labels: string[] = transactionStatistic.map((item) =>
    moment.utc(item.date).format(DATE_ONLY_FORMAT)
  )
  const totalIn: number[] = transactionStatistic.map((item) => item.totalIn)
  const totalOut: number[] = transactionStatistic.map((item) => Number(item.totalOut.toFixed(2)))
  // series.push({name: intl.formatMessage({id: 'transaction.totalIn'}), data: totalIn})
  series.push({name: intl.formatMessage({id: 'transaction.totalOut'}), data: totalOut})
  return {series, labels}
}
